export default __webpack_public_path__ + "static/media/chest-2.25f8bf9e.webp";